// import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //引入element语言包
 import zhLocale from "element-ui/lib/locale/lang/zh-TW";
const zh = {
  Topic: {
    articlelist: {
      msg: `話題`,
      all: `全部`,
      title: `編輯推薦`,
      HotList: `熱門話題`
    },
    articleview: {
      MSG: `發佈於`,
      Collection: `收藏`,
      share: `分享`,
      sgL_ReprintedSourceTitle: `轉載來源：`,
      Type: `類型：`,
      key: `關鍵字：`,
      might: `您可能會想看`
    }
  },
  message: {
    operatesuccessfully: "操作成功",
    operationfailure: "操作失敗",
    not_found: "未找到該數據",
    server_error: "服務器錯誤",
    Request_parameter_error: "請求參數報錯",
    Interface_address_error: "接口地址错误",
    information: "登錄信息已過期，請重新登錄",
    permission: "暂无权限,請聯係管理員",
    server_timed_out: "连接服务器超时",
    have_no_right: "没有权限",
    path_not_found: "请求路径找不到"
  },
  login: {
    title: "标题",
    username: "请输入用户名",
    password: "请输入密码"
  },
  Index: {
    SelectedFilms: `精選影片`,
    more: `更多`,
    FeedCloud: `尋寶雲短片`,
    Copylinks: `複製連結`,
    bookmark: `收藏`,
    share: `分享`,
    flag: `檢舉`,
    albumHotList: `本週熱門相簿`,
    eventList: `近期拍攝活動`,
    HotList: `熱門新聞`,
    albumList: `熱門相簿`,
    articleList: `熱門話題`
  },
  Activitys: {
    ActiveList: {
      msg: `活動列表`,
      favor: `收藏`,
      sgL_ActivityDateF: `日期`,
      KMKeywor: `活動名稱`,
      sum: `共`,
      photoCount: `个相簿`,
      sgL_TypeF: `類型`,
      sgL_AreaF: `地點`,
      sgL_StatusF: `報名狀態`,
      msg2: `過去活動列表`,
      screen: `篩選`,
      activitydate: `活動日期`,
      startdate: `開始日期`,
      enddate: `結束日期`,
      city: `所在城市`,
      placeholder: `請選擇城市`,
      type: `活動類型`,
      remark: `活動附註`,
      refresh: `重置`,
      SendMessage: `我要提供活動資訊`
    },
    Activeview: {
      share: `分享`,
      sgL_ActivityDatesF: `活動日期`,
      sgL_Address: `舉辦地點`,
      sgL_KMKeyworldF: `賽事項目`,
      sgL_UnitTitle: `主辦單位`,
      sgL_StatusF: `報名狀態`,
      sgL_EndApplyDateF: `報名截止日期`,
      sglActivityUrl: `活動網址`,
      sglActivityUrl2: `其他連結`,
      EventAlbum: `賽事相簿`,
      msg: `日期相近的活動`
    },
    profileBookmarkEvent: {
      msg1: `過去活動`,
      msg2: `日期`,
      msg3: `活動名稱`,
      msg4: `類型`,
      msg5: `地點`,
      msg6: `報名狀態`,
      msg7: `取消收藏`,
      msg8: `2019/06/17 (日)`,
      msg9: `隘寮下的沿山古道(少壯馬)【雙日賽】`,
      msg10: `21K,10K,5K`,
      msg11: `路跑`,
      msg12: `新北市`,
      msg13: `已截止報名`,
      msg14: `2018/05/04 (日)`,
      msg15: `2020 悠遊曾南-第三屆八百壯士超馬系列`,
      msg16: `10K,兒童組`,
      msg17: `單車`,
      msg18: `新北市`,
      msg19: `已截止報名`,
      msg20: `2016/10/24 (日)`,
      msg21: `親子組,成人組`,
      msg22: `單車`,
      msg23: `新北市`,
      msg24: `已截止報名`,
      msg25: `未來活動`,
      msg26: `05/17 (日)`,
      msg27: `06/22 (日)`,
      msg28: `3/23 報名`,
      msg29: `07/14 (日)`
    },
    SendMessage: {
      information: `提供活動資訊`,
      activities: `歡迎大家向我們提供體育活動資訊，我們將會儘快將有關資訊刊登於`,
      Activitylist: `活動列表`,
      on: `上。`,
      ActivityName: `活動名稱`,
      activityType: `活動類型（可多選）`,
      activityUrl: `活動網址`,
      area: `活動地點`,
      sgL_City: `請選擇地區`,
      sgL_Area: `請選擇縣市`,
      sgL_Address: `詳細地址`,
      placeholder: `詳細地點`,
      activityData: `活動日期`,
      msg: `至`,
      startdate: `開始日期`,
      enddate: `結束日期`,
      submit: `提交`,
      activityStartData: `報名日期`,
      activerules: {
        title: `請輸入活動名稱`,
        activityType: `請輸入活動類型`,
        activityUrl: `請輸入活動鏈接`
      }
    }
  },

  header: {
    albumIndex: "相簿",
    eventList: "活動",
    blog: "網誌",
    articleList: "話題",
    VideoIndex: "影音",
    Cloudshort: "雲短片",
    title: "尋寶網",
    search: "搜尋",
    uploadImage: "上傳照片/建立相簿",
    customerPublish: "個人主頁",
    feed: "動態主頁",
    mobile: "直播",
    admin: "管理員後台",
    loginout: "登出",
    notlogin: "未登入",
    cusLogin: "登入",
    customerInfo: "查看我的個人檔案",
    MoreProgram: "我們的節目",
    Activity: "活動網頁",
    Citizen: "最強市民飆5K",
    Latestnotice: "最新通知",
    copyright: "尋寶網 SOONNET.org 版權所有 © 2021",
    Uploadphotos: "上傳照片或相簿",
    Uploadshortvideos: "上傳短視頻",
    Publishblogposts: "發佈網誌帖文",
    Checkprofile: "查看我的個人主頁",
    Websitelanguage: "網站語言",
    TraditionalChinese: "繁體中文",
    Officialchannel: "官方頻道",
    Liveevent: "賽事直播",
    Exclusiveprogram: "獨家節目",
    CommunityDynamics: "社群動態",
    RecentSearches: "最近搜尋",
    Checkprofile_: "全部分類",
    EventInformation: "活動資訊"
  },
  Album: {
    albumIndex: {
      type: "類型",
      Hot: "本週熱門",
      more: "更多",
      Latestupload: "最新上傳",
      Uploadphotos: "上傳相片",
      Ranking: "攝影師排行",
      Ranking_: "排名",
      photographer: "攝影師",
      Collection: "本週合集",
      Compilationtitle: "合輯名稱",
      Numberalbums: "相簿數"
    },
    albumList: {
      Photoalbumlist: "相簿一覽",
      all: "全部",
      sorting: "排序：",
      orderbyhot: "按最後更新",
      Bypopularity: "按熱門程度"
    },
    albumviewDetail: {},
    albumviewFaceRecognition: {
      Uploadfacial: "上傳臉部相片進行搜尋",
      Uploadtitle:
        "點擊上方加號來添加頭像照片進行搜尋，再按下方按鈕進行臉部搜尋。",
      Upload: "人臉搜尋說明",
      facesearch: "進行臉部搜尋",
      Startfacesearch: "開始臉部搜尋"
    },
    albumviewPhoto: {
      startdate: "開始時間",
      enddate: "結束時間",
      Bibsearch: "號碼布搜尋",
      Facesearchphotograph: "面部搜尋相片",
      sorting: "排序：",
      orderbyhot: "按最後更新",
      Bypopularity: "按熱門程度",
      browse: "瀏覽",
      collect: "收藏",
      DownloadHD: "下載 (高清壓縮)",
      Downloadlossless: "下載 (原始無損)",
      prevtext: "上一頁",
      nexttext: "下一頁",
      Clicktogo: "點擊前往",
      textcontent: '按 "讚好" 或 "收藏" 請先登入',
      Login: "登入",
      title: "標題",
      Lastpage: "上一張",
      nextpage: "下一張"
    },
    albumviewPhotoolds: {
      browse: "瀏覽",
      collect: "收藏",
      DownloadHD: "下載 (高清壓縮)",
      Downloadlossless: "下載 (原始無損)",
      Photo: "相片",
      copy: "複製",
      good: "讚好",
      share: "分享",
      accuse: "檢舉",
      Photoalbum: "相簿一覽",
      photoDetail: "相簿描述及留言",
      Albumdescription: "相簿描述",
      CShootTimerF: "拍攝日期：",
      CAddTimerF: "上傳日期：",
      CMasterSortStr: "類型：",
      shortWebUrl: "短鏈接：",
      keyword: "關鍵字：",
      leaveword: "留言",
      startdate: "開始時間",
      enddate: "結束時間",
      Bibsearch: "號碼布搜尋",
      Facesearch: "面部搜尋相片",
      AuthCheck: "查找無法識別的相片,共",
      identified: "已識別",
      piece: "張",
      unrecognized: "未識別",
      unidentifiable: "無法識別",
      update: "編輯/新增",
      delete: "刪除相簿",
      sorting: "排序：",
      orderbyhot: "按最後更新",
      Bypopularity: "按熱門程度",
      Clicktogo: "點擊前往",
      prevtext: "上一頁",
      nexttext: "下一頁",
      textcontent: '按 "讚好" 或 "收藏" 請先登入',
      Login: "登入",
      title: "標題",
      Lastpage: "上一張",
      nextpage: "下一張",
      asc: "-升序",
      desc: "-降序"
    },
    albumviewPhotostreamItem: {
      viewcount: "瀏覽次數"
    },
    collection: {
      Bibsearch: "號碼布搜尋",
      Collectionintroduction: "合集簡介",
      Lastupdatetime: "最後更新時間"
    },
    collectionlist: {
      Setlist: "合集列表"
    },
    photoview: {
      Lastpage: "上一張",
      nextpage: "下一張",
      DownloadHD: "下載 (高清壓縮)",
      Downloadlossless: "下載 (原始無損)",
      Returnalbum: "返回相簿",
      Slideshow: "以幻燈片播放",
      del: "刪除",
      good: "讚好",
      share: "分享",
      collect: "收藏",
      Download: "下載",
      shortWebUrl: "短網址",
      copy: "複製",
      view: "檢視",
      leaveword: "留言",
      Cameramanufacturer: "相機製造商",
      Cameratype: "相機型號",
      size: "尺寸",
      Dateshooting: "拍攝日期",
      aperture: "光圈",
      exposure: "曝光度",
      Focallength: "焦距",
      Luminancevalue: "亮度值",
      Exposurecompensation: "曝光補償",
      sensitivity: "ISO 感光度",
      flashlight: "閃光燈",
      Exposureprogram: "曝光程式",
      Photometricmode: "測光模式"
    },
    singleCollection: {},
    uploadImage: {
      Selectpicture: "選擇圖片",
      uploading: "上傳",
      complete: "完成",
      Uploadandsave: "上傳並保存",
      the: "第",
      failed: "張圖片上傳失敗",
      filehere: " 將文件拖到此處",
      or: " 或",
      ClickuploadFile: " 點擊上傳文件",
      uploadfiles: " 只能上傳 jpg/png 格式",
      Waitfor: " 等",
      pictures: " 張圖片",
      pleasefeel: " 為優化用戶上傳速度，將隱藏部分上傳圖片，請放心點擊上傳。",
      use: "建議使用",
      Google: "Google Chrome 瀏覽器",
      upload: "進行上傳",
      and: "本網站有權在不予通知情況下移除違規或未經當事人同意之相片",
      piece: "張",
      Uploadprogress: "上傳進度",
      Photocount: "相片總數",
      Uploadedphoto: "已上傳相片",
      Currentrate: "當前速率",
      Timespent: "用時",
      Estimatedtime: "預計完成時間",
      uploadings: "正在上載",
      Addphoto: "增加相片",
      Deleteentire: "刪除整頁",
      Deleteall: "删除全部",
      Compactphoto: "相簿縮圖（建議尺寸: 450*450或以上）",
      title: "相簿標題",
      description: "相簿描述",
      keyword: `關鍵字（以 '，' 作分隔，不需加上空格）`,
      type: "相簿類型",
      time: "拍攝日期",
      active: "關聯活動",
      notnull: "無",
      date: "日期",
      activeDate: "活動日期",
      activeplaceholder: "請選擇活動日期",
      activeId: "活動",
      set: "私隱設定",
      open: "公開",
      notopen: "私人，只有您自己能觀看",
      ShareEXIF: "分享你每張相片的EXIF訊息",
      Include: "包括相機型號、光圈、快門等資料",
      hide: "隱藏",
      keywordplaceholder: "e.g. 渣打馬拉松,2021",
      dialogFormVisible: "您有已上傳但未保存的相片可重新載入",
      dtl: "注：只保留3天內未保存的相冊",
      del: "刪除",
      cancle: "取 消",
      submit: "確 定",
      sectionTitle: "建立相簿",
      EditsectionTitle: "編輯相簿",
      Editdomtitle: "編輯相簿 - 尋寶網",
      Uploaddomtitle: "上傳相片 - 尋寶網",
      albumRule: {
        title: "請輸入相簿名稱",
        time: "請輸入時間",
        type: "請輸入相簿類型"
      }
    },
    VRanking: {
      Ranking: "攝影師排行",
      Mostviewed: "點閱最多",
      Numberofclicks: "點閱次數",
      photographer: "攝影師",
      Mostuploaded: "上傳最多",
      Numberphotographs: "照片數目",
      Mostdownloaded: "下載最多",
      Numberdownloads: "被下載次數",
      largestcollection: "收藏最多",
      collections: "被收藏次數"
    }
  },
  blog: {
    all: {},
    cardList: {
      new: "最新發佈",
      Topbrowse: "最高瀏覽"
    },
    category: {},
    content: {
      Unsubscribe: `取消訂閱`,
      Subscribe: `訂 閱`,
      Hidepost: `隱藏帖文`,
      Display: `顯示帖文`,
      author: "作者",
      Subscribernumber: "訂閱人數",
      authorhighest: "作者最高瀏覽帖文",
      Popularpost: "人氣貼文",
      subscriber: "訂閱者",
      Editpost: "編輯帖文",
      Delpost: "刪除帖文",
      Releasetime: "發佈時間",
      copy: "複製",
      good: "讚",
      share: "分享",
      collect: "收藏",
      report: "舉報",
      Reproducedsource: "轉載來源：",
      Keywords: "關鍵字：",
      blognotes: "網誌內容為網友的心得交流平台，以上內容不代表尋寶網立場",
      Last: "上一則帖文",
      Next: "下一則帖文",
      Leave: "留 言",
      Editmessage: "編輯留言",
      Delmessage: "刪除留言",
      Leavemessage: "發表留言",
      Leaveplaceholder: "輸入你的留言",
      Haircloth: "發 佈",
      Subscribed: "已訂閱用戶",
      title: "標題",
      upPost: "修改留言",
      Confirmsubmission: "確認提交"
    },
    index: {},
    menu: {
      placeholder: "请选择"
    },
    userInfo: {
      Briefintroduction: "簡 介",
      Subscribernumber: "訂閱人數",
      Subscriber: " 訂 閱",
      authorhighest: "作者最高瀏覽帖文",
      blong: "網誌"
    }
  },
  common: {
    about: {
      t1: "關於我們",
      t2:
        "我們，專注創造體育賽事中最直接的感動。提供如臨其境的專業優質影音、相片等服務，完整串聯體育愛好者的新媒體網絡。",
      t3: `尋寶網 SOONNET
        從「體育賽事」開始，專注打造各項賽事的圖片/視頻報導，讓您沒有到場，卻身如其境，為賽手喝彩……`,
      t4: `我們是一個分享動感生活的互動平台。每日，我們的會員都在分享以運動為主的人或事，當中包括賽事、追焦、健康、娛樂、產品、風景等專業內容，透過網站及社交網絡媒體分享。我們每月都會協辦不同的賽事及運動推廣活動，透過這一系列的活動，將這非主流的生活態度，感染亞太地區各階層。`,
      t5: `我們致力於研究互聯網與新媒體，專注於社會網絡對體育行業的模式創新與商業實踐。`,
      t6: `我們的解決方案，覆蓋市場研究、行銷推廣、客戶維護、電子商務及媒體傳播。`,
      t7: `迄今針對亞太體育行業最完善的行業新網絡媒體解決方案提供商。`,
      "t7-2": `我們的使命`,
      t8: ` 幫助 體育愛好者 /
        參與者與體育行業各企業建立起互動橋樑，達到多贏。`,
      t9: `  幫助 體育愛好者 /
        參與者找到適合自己的體育產品，推行全面的直銷推廣B2B2C及O2M。`,
      t10: `幫助 體育行業企業建立自主品牌，推行全面的市場開拓。`,
      t11: `幫助 體育愛好者 /
        參與者與體育行業各企業建立環保意識，推行全面的環保計劃。`,
      t12: `我們的優勢`,
      t13: `1.
        立足香港及台灣，背靠中國內地，向亞太地區發展，成為中國內地與國際銜接的橋樑。`,
      t14: `2. 針對體育行業新網絡媒體解決方案提供商。`,
      t15: `3. 針對體育行業社會化網絡行銷服務提供商。`,
      t16: `4. 將體育產業直銷推廣帶入體育行業的服務商。`,
      t17: `5. 將體育行業進行整合，並提供 B2B2C / O2M。`,
      t18: `6. 將環保意識和網絡媒體相結合的服務提供商。`
    },
    advertise: {
      Advertisingcooperation: "廣告合作",
      Advertisinginquiry: "廣告查詢",
      t1: "如有任何廣告刊登及曝光的查詢，歡迎與我們聯絡：",
      Current: "目前廣告格式",
      JPG: ` 所有圖像廣告格式支援 JPG / PNG / GIF，檔案大小建議上限為 2
        MB。`,
      MP4: `  所有影像廣告格式支援 MP4 / MOV，檔案尺寸建議為 1280x720px
        或以下，檔案大小建議上限為 20 MB。`,
      code: `廣告代號`,
      Displayposition: `顯示位置`,
      Detailed: `詳細描述 / 適用頁面`,
      Fileformat: `檔案格式`,
      banner: `流動版首頁的大型橫幅`,
      detachable: `流動版各頁面底部的可關閉長形橫幅`,
      homepage: `首頁的圖像/影片可關閉彈窗`,
      unlimited: `圖像尺寸不限`,
      Image: `影像尺寸不大於 1280x720`,
      Largebanner: `類別主頁 (5選1) 的大型橫幅 (走馬燈形式顯示)`,
      "Largebanner-2": `類別主頁 (5選1) 右側的方形圖像/影片`,
      imageshould: `圖像闊度不大於 450px`,
      category: `類別主頁 (5選1) 頂部的長形橫幅`,
      Cover: `的封面圖片`,
      Refer: `參考 Facebook 規格`,
      in: `在`,
      or: `或`,
      Publish: `上發表推廣帖文 / 限時動態`,
      "unlimited-2": `不限`,
      advertising: `新版廣告格式 (陸續支援)`,
      Display: `顯示位置 (包含但不限於)`,
      dimensions: `尺寸規格`,
      Right: `右側直幅`,
      Audio: `影音`,
      Searchpage: `搜尋頁面`,
      squarebanner: `右側類方形橫幅`,
      topic: `話題`,
      Topicinsidepage: `話題內頁`,
      Insidepage: `影音內頁`,
      Longbanner: `長形橫幅`,
      Movie: `影片一覽`
    },
    avatar: {},
    comment: {
      opinion: `提出意見`,
      t1: `如閣下於使用本網站時遇上問題、有任何建議或錯誤回報，歡迎在以下意見欄提出，我們將會收集您的意見。`,
      label: `回報類別`,
      labelplaceholder: `請選擇類別`,
      optionlabel11: `會員帳戶相關／無法登入`,
      optionlabel12: `上載時遇上問題`,
      optionlabel13: `儲存空間不足`,
      optionlabel14: `著作權侵權問題`,
      optionlabel15: `欲移除內容（含有您本人肖像，或違規內容舉報）`,
      optionlabel16: `提出建議`,
      optionlabel17: `其他`,
      detail: `詳細内容`,
      detailplaceholder: `如與會員帳戶相關問題，請附上會員帳號或註冊電郵等資料（請注意，不需要提供密碼！）`,
      name: `聯絡人名稱`,
      email: `聯絡電郵`,
      response: `是否需要客服回覆？`,
      yes: `是`,
      no: `否`,
      submit: `提交`,
      opinionRules: {
        email: `請輸入郵箱`,
        content: `請輸入詳細內容`,
        type: `請選擇類別`,
        response: `請選擇是否需要客服回覆`
      }
    },
    commentsucces: {
      t1: "我們已收到您的回應",
      t2: "謝謝您的寶貴意見。",
      t3: "客服將會於三個工作天內處理您的案件。"
    },
    contact: {
      t1: "聯絡我們",
      t2: "一般查詢",
      t3:
        "如果您在使用尋寶網期間遇到問題需要協助或有其他的想法建議想要提出，歡迎透過以下的管道與我們聯繫，我們將竭誠為您服務。",
      t4: "聯絡電話",
      t5: "台灣區: 886-2-8792-9897 (分機806)",
      t6: "香港區: 852-2197-5506",
      t7: "按此聯繫",
      t8: "商業合作",
      t9:
        "歡迎各企業或策略聯盟伙伴的合作，無論是推廣活動、內容、技術或是其他方面的合作提案，都誠摯歡迎您來信，我們會儘快與您聯絡。",
      t10: "台灣地區",
      t11: "886-2-8792-9897 (分機806)",
      t12: "香港地區"
    },
    cooperate: {
      t1: "商務合作",
      t2:
        "歡迎各企業或策略聯盟伙伴的合作，無論是推廣活動、內容、技術或是其他方面的合作提案，都誠摯歡迎您來信，我們會儘快與您聯絡。",
      t3: "台灣地區",

      t4: "886-2-8792-9897 (分機806)",
      t5: "香港地區"
    },
    copyright: {
      t1: "尋寶網著作權保護政策",
      t2:
        "尋寶網尊重他人著作權，尋寶網服務條款亦明定，網友使用尋寶網服務不得侵害他人之著作權，因此，尋寶網呼籲使用者同樣尊重他 人之著作權。如果您認為尋寶網網站中之任何網頁內容或網友使用尋寶網服務已侵害您的著作權，建議您利用本處理辦法提出檢 舉，尋寶網將儘速為您處理。",
      t3: "檢舉著作權侵權處理辦法",
      t4: "一、權利人檢舉：",
      t5:
        "若尋寶網中之任何網頁內容或網友使用尋寶網服務已侵害您的著作權，請您郵寄至",
      t7:
        "1. 著作權人或著作權人之代理人之姓名或名稱、聯絡地址及聯絡電話、電子信箱或傳真號碼。",
      t8: "2. 被侵害之著作或製版之名稱。",
      t9:
        "3. 侵害著作權之內容所在頁面的網址(URL)等足使尋寶網確認該涉有侵權內容之相關資訊；並請求移除侵害著作權之內容。",
      t10:
        "4. 聲明著作權人確係基於善意，相信該侵權內容的使用是未經過合法授權或違反著作權法。",
      t11:
        "5. 聲明您於通知書所載相關資料均為真實，且您是著作權人或著作權人之代理人而為上開聲明。",
      t12:
        "6. 保證上開聲明如有不實致尋寶網或他人受損害者，著作權人願負法律責任。",
      t13: "檢舉窗口：尋寶網電郵",
      t14: "二、被檢舉人異議：",
      t15:
        "倘若您遭權利人檢舉而對於權利人的主張有異議，請您提供資料及聲明並經簽名或蓋章後，將通過電子郵件寄送予尋寶網。",
      t16: "[異議窗口：同上述權利人檢舉窗口。]",
      t17: "尋寶網處理原則：",
      t18:
        "1. 尋寶網接獲權利人的通知書後，將儘速移除權利人所主張涉有侵害著作權之網頁內容，並依據尋寶網與網友約定之聯絡方 式或網友留存之聯絡資訊，轉知網友涉有侵權情事。尋寶網得將處理情況，包括權利人的姓名、電子郵件或電話等提供予 該網友，俾該網友得直接與權利 人溝通解決爭議。若著作權侵權通知不完備者，尋寶網將會通知權利人補正相關資訊。",
      t19:
        "2. 請注意，網友的網頁內容倘若經權利人主張涉有侵害其著作權者，該內容一旦經尋寶網刪除後，尋寶網即無法再行回復。又網友如有三次涉有侵權情事者，尋寶網將終止該網友全部或部分之服務。",
      t20:
        "3. 但倘若網友對於權利人主張的侵權情事有異議，該網友得檢具通知文件要求尋寶網將該通知文件轉知權利人以表示異議；若網友的通 知不完備者，尋寶網將會通知網友補正相關資訊。尋寶網於接獲前項之通知文件後，會立即將該通知文件轉送給權利人。若權利人未於接獲該 通知文件之次日起十個工作日內，提出已對該網友提出訴訟之證明者，該網友將可以自行重新上傳該內容。",
      t21:
        "4. 前述權利人或網友的通知若不完備者，尋寶網得以其所提供之電子郵件或傳真通知補正相關資訊。",
      t22:
        "5. 權利人或網友必須於接到尋寶網補正通知之次日起五個工作日內完成補正，屆期未補正或未完全補正者，依著作權法之規定即為未提出通知。",
      t23:
        "6. 依據尋寶網隱私權政策條款規定，除經使用者同意或於提供服務之目的者外，尋寶網僅得依法令或政府機關之要求，提供使用者之識別資料予第三人。因之，您如依本辦法提出檢舉，尋寶網僅會依您的請求移除該侵權內容，不會提供您有關該使用者之識別資料。您如欲取得 該使用者資料，您應向地方法院檢察署或刑事警察局提出告訴，尋寶網將於前開單位來函要求提供使用者資料後，即刻配合提供之。"
    },
    deleteComment: {},
    Editor: {},
    eventsucces: {
      t1: "活動提交成功",
      t2: "感謝您的資訊，我們將會儘快把相關資訊進行刊登",
      t3: "返回活動主頁"
    },
    Footer: {
      t1: "本網站部份資訊由用戶提供，如侵犯您的版權，請",
      t2: "與我們聯繫",
      t3: `2021 尋寶網 SOONNET.org. All Rights
        Reserved.`
    },
    ImgCropper: {
      footer: "取消",
      primary: "確認"
    },
    initFoot: {},
    maintain: {},
    messageLink: {},
    Page: {},
    page2: {},
    pagination: {},
    privacy: {
      t1: "隱私權保護政策",
      t2: "隱私權保護政策的內容",
      t3:
        "尋寶網非常重視您的隱私權。請您閱讀以下有關隱私權保護政策的更多內容。",
      t4: "尋寶網使用您個人資料的方式",
      t5:
        " 本政策涵蓋的內容包括：尋寶網如何處理蒐集或收到的個人資料 (包括與您過去使用 尋寶網產品及服務相關的資料。) 個人資料是指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址或電話號碼。",
      t6: "本隱私權保護政策只適用於 尋寶網",
      t7:
        "本政策不適用於非 尋寶網所有或控制的公司，也不適用於非 尋寶網僱用或管理之人。",
      t8: "資料蒐集及使用",
      t9: "總論",
      t10:
        "在您註冊 尋寶網帳號、使用 尋寶網產品或服務、瀏覽 尋寶網網頁或某些合作夥伴的網頁，以及參加宣傳活動或贈獎遊戲時，尋寶網會蒐集您的個人資料。尋寶網也可能將商業夥伴或其他企業所提供的關於您的資訊與 尋寶網所擁有的您的個人資料相結合。",
      t11:
        "當您在 尋寶網註冊時，我們會詢問您的姓名、電子郵件地址、出生日期、性別及郵遞區號等資料。在您使用某些特定服務時，我們可能還會詢問您的住址、身分證號碼以及您財產的相關資料。在您註冊 尋寶網帳號並登入我們的服務後，我們就能辨別您的身分。 您得自由選擇是否提供個人資料給我們，但若特定資料欄位係屬必填欄位者，您若不提供該等資料則無法使用相關的尋寶網產品及服務。",
      t12:
        "尋寶網蒐集您與我們或我們的商業夥伴交易的資料，包括您使用我們所提供服務的相關資料。",
      t13:
        "尋寶網也自動接收並記錄您電腦和瀏覽器上的資料，包括 IP 位址、尋寶網 cookie 中的資料、軟體和硬體屬性以及您瀏覽的網頁紀錄。",
      t14:
        "在您使用尋寶網產品及服務期間，尋寶網得於全球地區將資料用作以下用途：客製化廣告及您看到的網頁內容、滿足您對產品和服務的要求、改進我們的服務、聯絡您、進行研究，以及提供內部及外部客戶不載有個人資料之市場分析或業務報告。",
      t15:
        "尋寶網蒐集、處理及利用個人資料之特定目的如下：行銷業務、消費者、客戶管理與服務、資訊通訊服務、網路購物及其他電子商務服務、廣告和商業行為管理業務以及其他契約、類似契約或法律關係管理之事務或業務。",
      t16: "資料蒐集及使用",
      t17: "資料分享與揭露",
      t18:
        "除非是為了向您提供您所要求的產品或服務、獲得您的授權，或有以下情形，否則 尋寶網不會向任何其他人士或非關係企業提供您的個人資料，或與之分享：",
      t19:
        "(i) 我們向已簽署保密協議書之代表 尋寶網執行業務或與我們共事的值得信賴的合作夥伴提供這些資料。這些公司可能會將您的個人資料用於協助 尋寶網就我們和行銷夥伴所提供產品及服務的事宜，與您進行溝通。但這些公司無獨立權利分享這些資料。",
      t20:
        "(ii) 我們對傳票、法院命令或法律程序作出回應、取得或行使法律權利，或對訴訟上之請求提出防禦。",
      t21:
        "(iii) 我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對尋寶網服務條款的違反，或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。",
      t22:
        "(iv) 如果 尋寶網全部或部分業務被其他公司收購或合併，我們會將您的個人資料移轉給該公司。如果發生這種情況，尋寶網會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。",
      t23:
        "(v) 尋寶網會根據您的個人資料向您展示精準式行銷廣告。廣告主 (包括廣告遞送公司) 可能假定那些瀏覽、點閱精準式行銷廣告或與廣告互動的人士符合精準式行銷標準，例如特定地理區域 內 18至24 歲的女性。",
      t24:
        "(vi) 在您瀏覽精準式行銷廣告或與廣告發生互動時，尋寶網不會向廣告主提供您的任何個人資料。然而，一旦瀏覽廣告或與廣告發生互動，即表示您同意廣告主可能會假定您符合展示型廣告所使用的精準式行銷標準。",
      t25:
        "(vii) 尋寶網廣告主包括金融服務提供者 (如銀行、保險代理人、證券經紀人及抵押貸款機構) 和非金融公司 (如商店、航空公司及軟體公司)。",
      t26:
        "(viii) 尋寶網與各行各業的供應商、合作夥伴、廣告主及其他服務提供者共事。欲瞭解所需產品或服務提供者的更多相關資料。",
      t27: "尋寶網會在您的電腦上設定並存取 尋寶網 cookie。",
      t28:
        "尋寶網允許在某些 尋寶網網頁上刊登廣告的其他公司在您的電腦上設定並存取 cookie。其他公司將根據其自訂的隱私權政策使用其 cookie，並非依據本政策。廣告主或其他公司不能存取 尋寶網的 cookie。",
      t29: "您查詢、修改及刪除個人帳號資料及偏好設定的能力",
      t30: "總論",
      t31:
        "您可隨時查詢、閱覽、複製及修改個人 尋寶網帳號資料，包括行銷偏好設定。",
      t32:
        "尋寶網可能會不定時在行銷偏好設定頁面上新增新類別的行銷訊息。瀏覽此頁面的使用者可選擇退出接收新類別的行銷訊息，或按照所收訊息中的指示取消訂閱這些訊息。",
      t33:
        "我們保有權利向您傳送 尋寶網服務相關的特定訊息 (如服務公告、管理訊息)，這些訊息被視為您尋寶網帳號的一部分，您無法選擇退出接收。",
      t34: "如果您要刪除您的尋寶網帳號，請與我們聯繫。",
      t35: "機密性和安全性",
      t36:
        "我們會將有權存取您個人資料之員工限於我們合理相信是為了向您提供產品或服務或為了完成工作而需要取得這些資料的員工。",
      t37:
        "我們已採取符合法規要求的實體、電子和程序防護措施，以保護您個人資料的安全。 酌是否給予同意。",
      t38: "隱私權保護政策修訂",
      t39:
        "尋寶網可不時修訂本政策。當我們在個人資料的處理上有重大變更時，會將通知傳送到您在尋寶網帳號中指定的主要電子郵件地址，或在我們的網站上張貼告示。",
      t40: "問題和建議",
      t41: "如果您有任何問題或建議，請填透過電郵與我們聯繫。",
      t42: "生效日期：2013年9月19日"
    },
    profileNavItem: {},
    Report: {
      placeholder: "標題最多28個中文字符",
      option: "請選擇",
      confirm: "確認提交"
    },
    /**太多了 先不弄 */
    service: {},
    SocialButton: {},
    sortLink: {},
    uploadImg: {},
    userComments: {
      message: "回复"
    },
    userCommentsItem: {
      placeholder: "請輸入留言內容",
      submitComment: "送出"
    }
  },
  Customer: {
    customerFavorite: {
      customerPublish: "發佈內容",
      customerFavorite: "我的收藏",
      customerPrivateMessage: "私訊",
      customerInfo: "設定",
      album: "收藏相簿",
      picture: "收藏相片",
      movie: "收藏影片",
      activity: "收藏活動",
      topic: "收藏文章",
      feed: "收藏動態",
      blog: "收藏網誌",
      search: "搜尋",
      loading: "正在加載",
      empty: "無數據",
      uncollect: "取消收藏",
      share: "分享",
      Nophoto: "無相片",
      uploader: "上傳者",
      Uploaddate: "上傳日期",
      newslessness: "無新聞",
      anechoic: "無影音",
      film: "影片貼文",
      photo: "相片貼文",
      text: "文字貼文",
      date: "日期",
      Controls: "操作",
      view: "查看",
      Pastactivity: "過去活動",
      Activityname: "活動名稱",
      type: "類型",
      Locations: "地點",
      Registrationstatus: "報名狀態",
      Futureactivity: "未來活動",
      day: "日"
    },
    customerInfo: {
      customerPublish: "發佈內容",
      customerFavorite: "我的收藏",
      customerPrivateMessage: "私訊",
      customerInfo: "設定",
      setting: "個人資料設定",
      Changepassword: "更改密碼",
      profilepicture: "個人頭像",
      Membername: "會員名稱",
      UsersName: "您顯示於社群上的名稱",
      MyVideoName: "短視頻名稱",
      customerMyVideoName: "您顯示於短視頻影片上的名稱",
      selfintroduction: "自我介紹",
      sgL_Myself: "您的簡短自我介紹",
      Sex: "性別",
      Male: "男",
      Female: "女",
      BirthF: "出生日期",
      SelfNetworkDiskF: "相簿空間",
      Havebeenused: "已使用",
      gross: "總量",
      information: "接收資訊",
      Soonnet: "我願意接收尋寶網Soonnet的最新資訊",
      no: "否",
      store: "儲存",
      Currentpassword: "現時密碼",
      newpw: "新密碼",
      repeatpw: "重新輸入密碼",
      changepw: "更改密碼",
      reciver: "接收的留言",
      sent: "發送的留言",
      search: "搜尋",
      msg: "留言內容",
      user: "用戶",
      date: "日期",
      Controls: "操作",
      check: "查看",
      del: "刪除",
      PwmodelRule: {
        pw: `請輸入現時密碼`,
        newpw: `請輸入新密碼`,
        repeatpw: `請重新輸入密碼`
      },
      customerModelrule: {
        sgL_UsersName: `請輸入用戶名`,
        sgL_MyVideoName: `請輸入短視頻名稱`
      }
    },
    customerLogin: {
      Login: "登入",
      user: "用戶名稱 / 電子郵件",
      password: "密碼",
      loggedin: "保持登錄",
      Forgopassword: "忘記密碼？",
      registerEmail: "尚未成為會員？",
      register: "按此註冊",
      or: "或",
      Facebook: "以 Facebook 帳號登入",
      loginRules: {
        name: `請填寫郵箱或用戶名`,
        password: `請填寫密碼`
      }
    },
    customerMessage: {
      customerPublish: "發佈內容",
      customerFavorite: "我的收藏",
      customerPrivateMessage: "私訊",
      customerInfo: "設定",
      reciver: "接收的留言",
      sent: "發送的留言",
      search: "搜尋",
      msg: "留言內容",
      user: "用戶",
      date: "日期",
      Controls: "操作",
      check: "查看",
      del: "刪除"
    },
    customerPrivateMessage: {
      msg: "私訊",
      replay: "回覆",
      reject: "删除",
      agree: "友好",
      sendMsg: "輸入對話",
      dialogue: "的對話"
    },
    customerPublish: {
      search: "搜尋",
      customerPublish: "發佈內容",
      Homepage: "用戶主頁",
      customerFavorite: "我的收藏",
      customerPrivateMessage: "私訊",
      customerInfo: "設定",
      Photoalbum: "相簿",
      videofeed: "我的影音動態",
      motionpicture: "我的動態相片",
      blog: "網誌",
      message: "我的留言",
      loading: "正在加載",
      Noalbum: "無相簿",
      processed: "已處理",
      piece: "張",
      bookmark: "收藏",
      share: "分享",
      del: "刪除",
      Noaudio: "無影音動態",
      link: "複製連結",
      publicity: "公開",
      Notpublic: "不公開",
      Nophotograph: "無動態相片",
      blogprofile: "設置網誌資料",
      Subscriberdata: "訂閱者資料",
      Postviews: "帖文觀看量",
      title: "標題",
      Totalpageviews: "總瀏覽量",
      Subscribe_browse: "訂閱瀏覽",
      Addsubscription: "加訂閱量",
      praise: "讚",
      releasedate: "發佈日期",
      subscriber: "訂閱者",
      Hide_post: "隱藏帖文",
      Display_post: "顯示帖文",
      Edit_post: "編輯帖文",
      del_post: "刪除帖文",
      suggestedsize: "文章封面（建議尺寸",
      uploadpictures: "上傳圖片",
      Blog_post_title: "網誌帖文標題",
      Article_content: "文章內容",
      Reprint_source: "轉載來源",
      Keywords: `關鍵字（以 "," 作分隔，不需加上空格）`,
      Chartered: "e.g. 賽事報導,路跑,渣打馬拉松",
      Open_state: "公開狀態",
      reveal: "顯示",
      Hidden: "隱藏",
      Cancel: "取消",
      save: "保存",
      Blog_flag: "網誌標誌",
      Blog_name: "網誌名稱",
      appears: "顯示於網誌的名稱",
      Blog_introduction: "網誌介紹",
      Blog_intro: "網誌簡短介紹",
      Storage_setting: "儲存設定",
      Received_message: "接收的留言",
      Sent_message: "發送的留言",
      Message_content: "留言內容",
      user: "用戶",
      date: "日期",
      Controls: "操作",
      check: "查看",
      Subscribed_subscriber: "已訂閱用戶"
    },
    customerPublishLook: {
      msg: "私 訊",
      agree: "加入好友",
      Photo_album: "相簿",
      film: "影片",
      group: "群組",
      search: "搜尋",
      loading: "正在加載",
      No_album: "無相簿",
      No_film: "無影片",
      No_data: "無数据",
      Apply: "申請入群",
      placeholder: "想對他說什麼",
      sendMessage: "發訊息"
    },
    customerRegist: {
      register: "註冊",
      mailbox: "郵箱",
      customerName: "用戶名稱（社群顯示名稱）",
      customerPwd: "密碼",
      customerRePwd: "重新輸入密碼",
      sex: "性別",
      Male: "男",
      Female: "女",
      customerBirth: "出生日期",
      checkDate: "選擇日期",
      customerArea: "所在地區",
      t1: "臺灣 - 臺北市",
      t2: "臺灣 - 新北市",
      t3: "臺灣 - 桃園市",
      t4: "臺灣 - 臺中市",
      t5: "臺灣 - 臺南市",
      t6: "臺灣 - 高雄市",
      t7: "臺灣 - 基隆市",
      t8: "臺灣 - 新竹市",
      t9: "臺灣 - 嘉義市",
      t10: "臺灣 - 新竹縣",
      t11: "臺灣 - 苗栗縣",
      t12: "臺灣 - 彰化縣",
      t13: "臺灣 - 南投縣",
      t14: "臺灣 - 雲林縣",
      t15: "臺灣 - 嘉義縣",
      t16: "臺灣 - 屏東縣",
      t17: "臺灣 - 宜蘭縣",
      t18: "臺灣 - 花蓮縣",
      t19: "臺灣 - 臺東縣",
      t20: "臺灣 - 澎湖縣",
      t21: "香港特別行政區",
      t22: "澳門特別行政區",
      t23: "中國大陸",
      t24: "海外地區",
      Soonnet: "我願意接收 尋寶網 Soonnet的最新資訊",
      agreed: "我已閱讀及同意",
      service: "服務條款",
      policy: "私隱條款",
      clause: "著作權條款",
      ors: "及",
      registerRules: {
        customerEmail: {
          error1: `請輸入郵箱地址`,
          error2: `請輸入正確的郵箱地址`
        },
        customerName: `請輸入社群名稱`,
        customerPwd: `請輸入6位以上的密碼`,
        customerRePwd: {
          error1: `請輸入密碼`,
          error2: `兩次密碼輸入不一致!`
        }
      }
    },
    forgotPassword: {
      Forgot_password: "忘記密碼",
      email: "輸入您的電子郵件，",
      link: "系統將會發送一封含有重設密碼連結的電郵給您。",
      mailbox: "（如無法順利收取郵件，請檢查您的垃圾郵箱）",
      Electronic_mail: "電子郵件",
      please: "如需協助，請",
      contact_us: "聯繫我們",
      registerEmailRules: {
        error1: "請輸入郵箱地址",
        error2: "請輸入正確的郵箱地址"
      },
      btntext: {
        title1: "重設密碼",
        title2: "秒後再次發送"
      }
    },
    registerEmail: {
      register: "註冊",
      submit: "提交"
    },
    registerSuccess: {
      register: "註冊成功",
      title: "您已成功註冊為尋寶網會員，請重新進行登錄。",
      toLogin: "返回登錄頁面"
    },
    resetPassword: {
      reset_password: "重設密碼",
      resetpassword: "請設定您的新密碼",
      newwpd: "新密碼",
      repeatPassword: "重新輸入新密碼",
      error1: "請輸入密碼",
      error2: "兩次密碼輸入不一致"
    },
    resetPwSuccess: {
      msg: "重設密碼成功",
      msg1: "您的密碼經已重設，請重新進行登錄。",
      msg2: "返回登錄頁面"
    }
  },
  loginFun: {
    certification: {
      authentication: "認證",
      userName: "姓名",
      videoName: "顯示的用戶名稱限最多六位中文字符",
      area: "所在地區",
      area_placeholder: "請選擇地區",
      verificationCode: "驗證碼",
      isCheck: "我已閱讀及同意",
      certificationTerms: "實名認證條款",
      or: "及",
      copyright: "著作權條款",
      promise: "當你按下按鍵時等同接受及承諾遵守有關條款",
      closealarmModal: "您已完成認證",
      verify: "確認",
      activerules: {
        email: `郵箱不能為空`,
        userName: `請輸入姓名`,
        area: `請選擇地區`,
        telNum: `請輸入電話號碼`,
        verificationCode: `輸入驗證碼`
      }
    },
    certificationFlow: {
      description: "實名認證流程及說明",
      authenticate: "為什麼要進行手機認證？",
      msg:
        "為確保尋寶網之用戶能獲得良好的使用環境，避免帳號申請浮濫及有心人士刊登違反法律之內容，用戶申請帳號時，需提供真實資料並透過手機認證，進行會員「帳號實名制」，確保用戶是帳戶的權益擁有人，且用戶須對於所刊登之內容負責。",
      protection: "實名認證保障及條款",
      certificationTerms: "按這裡查看",
      certification: "手機認證流程及說明",
      msg2:
        "已註冊用戶在已登入的情況下，會展示現時此帳號的電郵，確認要認證的帳號是否正確，如沒錯誤便可直接填寫下方的資料。",
      msg3: "新註冊用戶在完成註冊後再進入認證頁面頁",
      msg4: "填寫你的姓名資料。(此資料不會顯示在網頁內任何地方只用作認證記錄)",
      msg5:
        "填寫的名稱將會在影片或日後用作顯示的個人稱謂;限制最多六個位的中文字/12位英文及數字",
      msg6: `選擇現在認證的電話號碼"地區"`,
      msg7: `填寫現在認證的"電話號碼"`,
      msg8: `輸入手機認證號碼接收到的"認證碼"`,
      msg9: `點擊"實名認證條款"及"著作權條款"詳細閱讀有關條款，需同意勾選此項繼續進行認證`,
      msg10: `與第七點的"實名認證條款"相同只是提供直接閱讀，如已勾選第七步的選項可繼續進行認證`,
      msg11: `點擊"認證"完成整個認證流程及記錄`,
      comparison: `功能比對`,
      contrast: `功能對比`,
      Uncertified_member: `未認證會員`,
      Mobile_certified_member: `手機認證會員`,
      upload_photos: `活動 - 上傳相片`,
      Photo_likes: `活動 - 相片點讚`,
      Photo_sharing: `活動 - 相片分享`,
      Photo_collection: `活動 - 相片收藏`,
      bib_search: `路跑相片 - 號碼布搜尋`,
      face_Search: `路跑相片 - 相片人臉搜尋`,
      Community_Message: `社群 - 留言`,
      Community_Upload_photos: `社群 - 上傳照片`,
      Upload_short_videos: `社群 - 上傳短視頻`
    },
    certificationTerms: {
      t1: `實名認證條款`,
      t2: `為什麼要進行手機認證？`,
      t3: `為確保尋寶網之用戶能獲得良好的使用環境，避免帳號申請浮濫及有心人士刊登違反法律之內容，用戶申請帳號時，需提供真實資料並透過手機認證，進行會員「帳號實名制」，確保用戶是帳戶的權益擁有人，且用戶須對於所刊登之內容負責。`,
      t4: `認證流程及說明`,
      t5: `按這裡查看`,
      t6: `我的資料會外洩嗎？`,
      t7: `您提供的個人資料皆受到個資法及尋寶網隱私權保護政策保障，將僅用於會員身份認證、尋寶網服務提供與相關通知等，絕不任意洩漏給第三方，敬請協助本網站提供更好的服務及安心的體驗。`,
      t8: `著作權人或著作權人之代理人之姓名或名稱、聯絡地址及聯絡電話、電子信箱或傳真號碼。`,
      t9: `被侵害之著作或製版之名稱。`,
      t10: `侵害著作權之內容所在頁面的網址(URL)等足使尋寶網確認該涉有侵權內容之相關資訊；並請求移除侵害著作權之內容。`,
      t11: `聲明著作權人確係基於善意，相信該侵權內容的使用是未經過合法授權或違反著作權法。`,
      t12: `聲明您於通知書所載相關資料均為真實，且您是著作權人或著作權人之代理人而為上開聲明。`,
      t13: `保證上開聲明如有不實致尋寶網或他人受損害者，著作權人願負法律責任。`,
      t14: `相關條例`,
      t15: `為了提供更好的使用者體驗，若您同意並需要使用尋寶網服務的所有細項，必須經過尋寶網制定之系統認證，否則尋寶網無須提供完整的服務內容。`,
      t16: `您於註冊時須提供完整詳實且符合真實之個人資料，如因您虛偽登載導致尋寶網損失，尋寶網得索取損害賠償及懲罰性違約金並有權停止會員帳號使用權，且尋寶網無須負擔任何損害賠償責任，同時您應自負相關民刑事責任，如有涉犯刑事犯罪者，尋寶網將移司法單位處理。`,
      t17: `尋寶網提供「AOTP驗證服務」作為會員驗證的方式，「AOTP驗證服務」是以發送簡訊到指定電信簡碼後，同時驗證發送者SIM卡手機號碼與驗證碼的新一代電信驗證方式，用來提升既有簡訊OTP驗證的安全以確保您的用戶權益。`,
      t18: `您使用本服務時，應保證為該手機號碼的合法使用者，使用本服務後，您將為使用本服務的帳號之所有行為負責。`,
      t19: `真實登錄義務：`,
      t20: `若乙方同意並需要使用甲方服務的所有細項，必須經過甲方制定之系統認證，否則甲方無須提供完整的服務內容。`,
      t21: `乙方於註冊時須提供完整詳實且符合真實之個人資料，且乙方所登錄資料事後有變更時，應隨時於線上更新或利用會員服務申請變更之。若乙方故意登載不實之個人資料即構成違約事由，經甲方發現並通知乙方更正，乙方應於_7日內更正，如乙方仍未更正，甲方得停止其會員帳號使用權7日，且無須負擔任何損害賠償責任。如因乙方虛偽登載導致甲方損失，甲方得索取損害賠償及懲罰性違約金，同時乙方應自負相關民刑事責任（包括但不限於刑法偽變造文書、詐欺、妨礙電磁紀錄等相關罪章）。`,
      t22: `如乙方提供之個人資料有填寫不實，或原所登錄之資料已不符合真實而未更新，或有任何其他誤導之嫌，於乙方提供真實資料或更新資料前，甲方保留隨時暫停乙方使用各項服務之權利。`,
      t23: `使用者義務：`,
      t24: `在使用本服務過程中，您必須提供本服務之註冊與開通作業所需之您的手機號碼及其他個人資料及資訊，並應擔保您所提供資訊，皆真實、正確、現有且完整。您所提供之資訊若有變動，應立即向本公司主動更新，如您所提供之資料及個人資訊，若非真實、正確、未更新或不完整，應由您自行承擔相關損失，及本公司因此受之損害或損失。`,
      t25: `您應確保所使用手機及其資訊系統之安全，防止非法入侵、取得、竄改、毀損其中紀錄或資料之情形發生，並應安裝使用本服務所必須之軟體、韌體或其他程式碼。如所使用之手機因任何原因，有前述非法入侵等情事致您使用本服務而受有損害或損失者，將由您自行承擔。本公司依法採取相關措施，以保障您個人資料的安全，但不擔保您所填寫的資料在網路傳輸中的正確性，如果您發現有錯誤請立即通知本公司，並檢附相關資料請求更正，否則本公司將以獲取之資料內容作業。`,
      t26: `使用者使用應依本服務頁面的指示，除有特別狀況、規定者外，將可享受完整的合作店家會員權益及其優惠服務。`,
      t27: ` (以下簡稱「本站」)，為了提供更好的使用者體驗，依照本站AOTP驗證`,
      t28: `服務使用條款（以下簡稱「本條款」），提供AOTP驗證服務(以下簡稱「本服務」)`,
      t29: `作為帳號驗證的方式，使用本服務前請務必詳細閱讀本條款內容以保障權益，當您已開始使用本服務時，視為已確實閱讀、瞭解並同意遵守本條款。`,
      t30: `一、服務內容及基本規範`,
      t31: `本服務是以發送簡訊到指定電信簡碼後，同時驗證發送者SIM卡手機號碼與驗證碼的新一代電信驗證方式，用來提升既有簡訊OTP驗證的安全以確保您的用戶權益，目前僅接受中華電信、遠傳電信、台灣大哥大、亞太電信、台灣之星電信月租型用戶。`,
      t32: `使用本服務之後，將會在您的下期電信帳單中，收取每封3元的加值簡訊費用。此費用係五大電信業者、簡訊與驗證服務業者之驗證服務費用，本站無收取任何費用，也不介入認證費用之收付。`,
      t33: `二、服務使用責任與義務`,
      t34: `您使用本服務時，應保證為該手機號碼的合法使用者，使用本服務後，您將為使用本服務的帳號之所有行為負責。`,
      t35: `您於使用本服務時，除應遵守中華民國法令、國際網際網路規定與慣例、本站使用者條款及本條款規範，如您違反規定，致本站受有損害或支出費用（包括但不限於訴訟費及律師費）者，應負損害賠償責任。如有涉犯刑事犯罪者，本站並得移請主管機關或司法單位處理。`,
      t36: `本服務傳送前述簡訊驗證碼之手機號碼，申裝人應予以妥善保管，如未盡保管義務所生之損害概由傳送前述簡訊驗證碼之手機號碼申裝人自行負責。若使用此手機號碼進行驗證者為無權使用，則另應負法律責任。`,
      t37: `三、服務之停止或終止`,
      t38: `您同意本站各級管理者基於其自行之考量，有權隨時終止本服務或其任何部分，包含但不限於取消本服務之帳號認證，禁止用於本服務之手機號碼。`,
      t39: `若您有違反本條款、本站使用者條款、相關法令或有其他不當使用本站之情形，本站得不經通知，逕行限制或終止您使用本站服務之權利，您不得因此要求補償或賠償。`,
      t40: `四、免責聲明`,
      t41: `本站就本服務不負任何擔保責任，且不保證本服務之穩定、無誤、安全及不中斷。如果使用者因系統中斷、障礙而導致認證失敗，廠商之費用將無法退還。但本站願對您的申訴進行妥適瞭解，並適度反應予提供本服務之廠商。`,
      t42: `本站有權隨時修正本條款，唯在修改或變更後，恕不再個別另行個別通知，您不得因此而要求任何補償或賠償。`
    },
    certificationTermsIframe: {
      t1: `實名認證條款`,
      t2: `為什麼要進行手機認證？`,
      t3: `為確保尋寶網之用戶能獲得良好的使用環境，避免帳號申請浮濫及有心人士刊登違反法律之內容，用戶申請帳號時，需提供真實資料並透過手機認證，進行會員「帳號實名制」，確保用戶是帳戶的權益擁有人，且用戶須對於所刊登之內容負責。`,
      t4: `我的資料會外洩嗎？`,
      t5: `您提供的個人資料皆受到個資法及尋寶網隱私權保護政策保障，將僅用於會員身份認證、尋寶網服務提供與相關通知等，絕不任意洩漏給第三方，敬請協助本網站提供更好的服務及安心的體驗。`,
      t6: `著作權人或著作權人之代理人之姓名或名稱、聯絡地址及聯絡電話、電子信箱或傳真號碼。`,
      t7: `使被侵害之著作或製版之名稱。用者義務：`,
      t8: `侵害著作權之內容所在頁面的網址(URL)等足使尋寶網確認該涉有侵權內容之相關資訊；並請求移除侵害著作權之內容。`,
      t9: `聲明著作權人確係基於善意，相信該侵權內容的使用是未經過合法授權或違反著作權法。`,
      t10: `聲明您於通知書所載相關資料均為真實，且您是著作權人或著作權人之代理人而為上開聲明。`,
      t11: `保證上開聲明如有不實致尋寶網或他人受損害者，著作權人願負法律責任。`,
      t12: `相關條例`,
      t13: `為了提供更好的使用者體驗，若您同意並需要使用尋寶網服務的所有細項，必須經過尋寶網制定之系統認證，否則尋寶網無須提供完整的服務內容。`,
      t14: `您於註冊時須提供完整詳實且符合真實之個人資料，如因您虛偽登載導致尋寶網損失，尋寶網得索取損害賠償及懲罰性違約金並有權停止會員帳號使用權，且尋寶網無須負擔任何損害賠償責任，同時您應自負相關民刑事責任，如有涉犯刑事犯罪者，尋寶網將移司法單位處理。`,
      t15: `尋寶網提供「AOTP驗證服務」作為會員驗證的方式，「AOTP驗證服務」是以發送簡訊到指定電信簡碼後，同時驗證發送者SIM卡手機號碼與驗證碼的新一代電信驗證方式，用來提升既有簡訊OTP驗證的安全以確保您的用戶權益。`,
      t16: `您使用本服務時，應保證為該手機號碼的合法使用者，使用本服務後，您將為使用本服務的帳號之所有行為負責。`,
      t17: `真實登錄義務：`,
      t18: `若乙方同意並需要使用甲方服務的所有細項，必須經過甲方制定之系統認證，否則甲方無須提供完整的服務內容。`,
      t19: `乙方於註冊時須提供完整詳實且符合真實之個人資料，且乙方所登錄資料事後有變更時，應隨時於線上更新或利用會員服務申請變更之。若乙方故意登載不實之個人資料即構成違約事由，經甲方發現並通知乙方更正，乙方應於_7日內更正，如乙方仍未更正，甲方得停止其會員帳號使用權7日，且無須負擔任何損害賠償責任。如因乙方虛偽登載導致甲方損失，甲方得索取損害賠償及懲罰性違約金，同時乙方應自負相關民刑事責任（包括但不限於刑法偽變造文書、詐欺、妨礙電磁紀錄等相關罪章）。`,
      t20: `如乙方提供之個人資料有填寫不實，或原所登錄之資料已不符合真實而未更新，或有任何其他誤導之嫌，於乙方提供真實資料或更新資料前，甲方保留隨時暫停乙方使用各項服務之權利。`,
      t21: `使用者義務：`,
      t22: `在使用本服務過程中，您必須提供本服務之註冊與開通作業所需之您的手機號碼及其他個人資料及資訊，並應擔保您所提供資訊，皆真實、正確、現有且完整。您所提供之資訊若有變動，應立即向本公司主動更新，如您所提供之資料及個人資訊，若非真實、正確、未更新或不完整，應由您自行承擔相關損失，及本公司因此受之損害或損失。`,
      t23: `您應確保所使用手機及其資訊系統之安全，防止非法入侵、取得、竄改、毀損其中紀錄或資料之情形發生，並應安裝使用本服務所必須之軟體、韌體或其他程式碼。如所使用之手機因任何原因，有前述非法入侵等情事致您使用本服務而受有損害或損失者，將由您自行承擔。本公司依法採取相關措施，以保障您個人資料的安全，但不擔保您所填寫的資料在網路傳輸中的正確性，如果您發現有錯誤請立即通知本公司，並檢附相關資料請求更正，否則本公司將以獲取之資料內容作業。`,
      t24: `使用者使用應依本服務頁面的指示，除有特別狀況、規定者外，將可享受完整的合作店家會員權益及其優惠服務。`,
      t25: `(以下簡稱「本站」)，為了提供更好的使用者體驗，依照本站AOTP驗證`,
      t26: `服務使用條款（以下簡稱「本條款」），提供AOTP驗證服務(以下簡稱「本服務」)`,
      t27: `作為帳號驗證的方式，使用本服務前請務必詳細閱讀本條款內容以保障權益，當您已開始使用本服務時，視為已確實閱讀、瞭解並同意遵守本條款。`,
      t28: `一、服務內容及基本規範`,
      t29: `本服務是以發送簡訊到指定電信簡碼後，同時驗證發送者SIM卡手機號碼與驗證碼的新一代電信驗證方式，用來提升既有簡訊OTP驗證的安全以確保您的用戶權益，目前僅接受中華電信、遠傳電信、台灣大哥大、亞太電信、台灣之星電信月租型用戶。`,
      t30: `使用本服務之後，將會在您的下期電信帳單中，收取每封3元的加值簡訊費用。此費用係五大電信業者、簡訊與驗證服務業者之驗證服務費用，本站無收取任何費用，也不介入認證費用之收付。`,
      t31: `二、服務使用責任與義務`,
      t32: `您使用本服務時，應保證為該手機號碼的合法使用者，使用本服務後，您將為使用本服務的帳號之所有行為負責。`,
      t33: `您於使用本服務時，除應遵守中華民國法令、國際網際網路規定與慣例、本站使用者條款及本條款規範，如您違反規定，致本站受有損害或支出費用（包括但不限於訴訟費及律師費）者，應負損害賠償責任。如有涉犯刑事犯罪者，本站並得移請主管機關或司法單位處理。`,
      t34: `本服務傳送前述簡訊驗證碼之手機號碼，申裝人應予以妥善保管，如未盡保管義務所生之損害概由傳送前述簡訊驗證碼之手機號碼申裝人自行負責。若使用此手機號碼進行驗證者為無權使用，則另應負法律責任。`,
      t35: `三、服務之停止或終止`,
      t36: `您同意本站各級管理者基於其自行之考量，有權隨時終止本服務或其任何部分，包含但不限於取消本服務之帳號認證，禁止用於本服務之手機號碼。`,
      t37: `若您有違反本條款、本站使用者條款、相關法令或有其他不當使用本站之情形，本站得不經通知，逕行限制或終止您使用本站服務之權利，您不得因此要求補償或賠償。`,
      t38: `四、免責聲明`,
      t39: `本站就本服務不負任何擔保責任，且不保證本服務之穩定、無誤、安全及不中斷。如果使用者因系統中斷、障礙而導致認證失敗，廠商之費用將無法退還。但本站願對您的申訴進行妥適瞭解，並適度反應予提供本服務之廠商。`,
      t40: `本站有權隨時修正本條款，唯在修改或變更後，恕不再個別另行個別通知，您不得因此而要求任何補償或賠償。`
    },
    login: {
      administrator: "尋寶網管理後臺",
      username: "用戶名稱",
      password: "請輸入密碼",
      loginmodel: "登入",
      or: "或",
      facebook: "以 Facebook 帳號登入",
      loginrules: {
        username: `請輸入用戶名`,
        password: `請輸入密碼`
      }
    }
  },
  Social: {
    cloubDetail: {
      lookCount: "觀看次數"
    },
    cloubTool: {},
    CreateFeed: {
      Newpost: "新增帖文",
      ShareContent: "今天想分享甚麼？",
      uploadUrl: "新增相片",
      Newfilm: "新增影片",
      save: "發佈"
    },
    DataView: {
      bookmark: "收藏",
      flag: "檢舉",
      delbolg: "刪除帖文",
      thumbs: "給讚",
      comment: "回應",
      share: "分享",
      placeholder: "發表你的回應..."
    },
    DisplayVideo: {
      clone: "複製連結",
      bookmark: "收藏",
      share: "分享",
      flag: "檢舉",
      recover: "回复",
      keyWord: "關鍵字",
      placeholder: "發表你的回應...",
      placeholder2: "發表你的回复...",
      hit: "最Hit 影片主播"
    },
    Feed: {
      date: "按這裡選日期查看",
      loading: "數據加載中...",
      loading2: "暫無更多數據"
    },
    FeedCard: {},
    FeedCloud: {
      sorting: " 排序：",
      newvideo: " 最New影片",
      hitvideo: " Hit播影片",
      uploadvideo: " 上傳影片",
      clone: "複製連結",
      bookmark: "收藏",
      share: "分享",
      flag: "檢舉"
    },
    FeedHome: {},
    FeedPerson: {},
    Heart: {},
    moreMenu: {},
    MyDynamic: {
      msg: "為甚麼你還沒有嘗試發佈動態？"
    },
    MyDynamicPic: {
      photo: `相片`,
      film: `影片`,
      Search_dynamics: `搜尋動態`,
      clone: `複製連結`,
      open: `公開`,
      noOpen: `不公開`,
      del: `刪除`
    },
    ReportMask: {
      msg: `此影片已被檢舉為"不當內容"等待確認。管理員確認後影片將被隱藏或刪除`
    },
    singleVideo: {},
    TempPage: {},
    UploadStep: {},
    UserFeedInfo: {
      login: "未登陸，點擊此處登陸",
      home: "動態主頁",
      video: "影音動態牆",
      group: "群 組",
      user: "好友列表",
      comments: "私訊"
    },
    video: {},
    VideoUpload: {
      msg: "將文件拖曳到此處，或",
      Clickupload: "點擊上傳",
      Selected: "已選擇文件：",
      Only: "只支援上傳 mp4/mov/mpg/3gp/flv 檔案格式",
      uploads: "只接受上傳影片時長不多於60秒",
      recommended: "建議影片不低於1280x720及不高於2560x1440 為佳",
      website: "本網站有權在不予通知情況下移除違規影片及保留相關追究權利",
      next: "下一步",
      Uploadprogress: "上傳進度",
      thumbnail: "*影片縮圖（不大於尺寸: 1280*720）",
      custom: "上載自訂縮圖",
      image_yourself: "自行上傳封面圖",
      Filename: "檔案名稱",
      Filesize: "檔案尺寸",
      File_size: "檔案大小",
      uploader: "上傳者",
      Uploadtime: "上傳時間",
      Filmtitle: "影片標題",
      Filmdescription: "影片描述",
      key: "關鍵字（以 ',' 作分隔，不需加上空格）",
      eg: "e.g. 開心、劇情、興趣...",
      privacy: "私隱設定",
      placeholder: "请选择",
      last: "上一步",
      Videolink: "影片連結",
      ok: "完成",
      processing: "正在處理中",
      Tips: "提示",
      msg2: "請確認內容，沒問題按下一步否則請返回上一步修改",
      cancel: "取消",
      confirm: "确定",
      msg3: "已上傳的影片封面圖"
    },
    group: {
      detailCard: {
        bookmark: "收藏",
        share: "分享",
        flag: "檢舉",
        EditorialPost: "編輯貼文",
        DeletePost: "刪除帖文"
      },
      groupAccList: {
        search: "搜尋現有朋友用戶名稱",
        search1: "搜尋朋友列表用戶名稱",
        search2: "搜尋朋友列表",
        Searchresult: "搜尋結果",
        packup: "收起",
        unfold: "展開",
        Removed: "從好友列表移除",
        blockFriend: "黑名單",
        friend: "好友",
        a: "個",
        batchoperation: "批量操作"
      },
      groupAddAcc: {
        search_user: "搜尋用戶名稱",
        join: "搜尋用戶 / 群組名稱加入",
        keys: "關鍵字",
        placeholder: "请选择",
        Friendusers: "朋友用戶",
        Groupsfriends: "朋友群組",
        Searchingfriends: "搜尋朋友",
        searchresult: "搜尋結果",
        Invitation: "邀請",
        Join_: "加入",
        been_invited: "已被我邀請",
        remove: "移除",
        removedfriend: "移除朋友",
        Approve: "批准成為朋友",
        Refuse: "拒絕成為朋友",
        requests: "用戶申請入群",
        requests_: "正在邀請用戶入群",
        Friendstatus: "朋友狀況",
        Groupstatus: "群組狀況",
        application: "批准申請",
        rejection: "拒絕申請",
        admission: "我申請入群狀況",
        Unjoin: "取消加入",
        Applying: "正在申請入群",
        invitedgroup: "被邀請入群",
        Agreepass: "同意通過",
        Refusepass: "拒绝通過"
      },
      groupBlackList: {
        search_user: "搜尋用戶名稱",
        Searchingusers: "搜尋用戶",
        searchresult: "搜尋結果",
        packup: "收起",
        unfold: "展開",
        blacklist: "加入黑名單",
        masking: "拉黑",
        Blockingusers: "拉黑用戶",
        a: "個",
        batchoperation: "批量操作",
        Removedblacklist: "從黑名單移除"
      },
      groupDetail: {
        Reducedpresentation: "縮減展示",
        ShowMore: "展示更多",
        placeholder: "按這裡選日期查看",
        hidden: "已被隱藏的內容",
        PhotoAlbumSharing: "相簿分享",
        ShortVideoSharing: "短視頻分享",
        Editing: "編輯",
        delpost: "刪除帖文",
        AddPost: "新增帖文",
        FriendsInGroup: "群組內你認識的朋友",
        hiddenpost: "隱藏帖文",
        Afterhiding: "隱藏帖文後,只有群主及自己能看到內容",
        placeholderText: "今天想分享甚麼？",
        fileupload: "點按選取檔案上傳",
        shortlink: "輸入分享相簿短鏈接？",
        upload: "將文件拖曳到此處，或",
        clickupload: "點擊上傳",
        checkupload: "已選擇文件：",
        type: "只支援上傳 mp4/mov/mpg/3gp/flv 檔案格式",
        msg: "本網站有權在不予通知情況下移除違規影片及保留相關追究權利",
        msg2: "*影片縮圖（不大於尺寸: 1280*720）",
        image: "上載自訂縮圖",
        File_name: "檔案名稱",
        widhei: "檔案尺寸",
        sgL_Size: "檔案大小",
        displayName: "上傳者",
        videoCreateTime: "上傳時間",
        videoTitle: "影片標題",
        placeholderTitle: "最多28個中英文數字符號",
        VideoDescription: "影片描述",
        keys: `關鍵字（以 "," 作分隔，不需加上空格）`,
        eg: "e.g. 開心、劇情、興趣...",
        PrivacySettings: "私隱設定",
        pleasechoose: "请选择",
        open: "公開",
        msg3: "群組，只有在這群組的朋友才看到",
        NULLOPEN: "不公開，只有得知影片連結的人才能觀看",
        NewPost: "新增貼文",
        Release: "發佈",
        ReportVueTitle: "標題",
        response: "發表你的回應...",
        Close: "取消",
        OK: "確定"
      },
      groupImg: {},
      groupList: {
        search_user: "搜尋用戶名稱",
        Settinggroups: "設置群組",
        placeholder: "请选择",
        Searchinguserlist: "搜尋用戶列表",
        Searchfriendlist: "搜尋好友列表",
        friendlist: "好友列表",
        cancel: "取消",
        Invitation: "邀請",
        GroupUser: "群組用戶",
        a: "個",
        Removegroup: "從群組移除",
        offsharing: "關閉分享影像",
        Closemessages: "關閉留言",
        rem: "移除組員",
        msg1: "分享影像",
        Openmessage: "開啟留言",
        Searchingusers: "搜尋用戶",
        searchresult: "搜尋結果",
        packup: "收起",
        unfold: "展開",
        batchoperation: "批量操作"
      },
      groupSetting: {
        setGroup: "設置群組",
        placeholder: "请选择",
        Groupflags: "群組標誌",
        groupname: "群組名稱",
        sgL_GroupName: "您顯示於群組上的名稱",
        groupdes: "群組介紹",
        sgL_GroupContent: "您的群組簡短介紹",
        foruserMessage: "留言及回覆",
        OPEN: "開放",
        NO_OPEN: "關閉",
        Groupvideo: "群組影音",
        Disable: "關閉群內發佈功能",
        Groupbackground: "群組背景",
        background_color: "背景顏色",
        wordcolor: "文字顏色",
        Delgroup: "刪除主群組",
        details: "注意刪除後主群組所有分享內容會被刪除",
        cancel: "取消",
        save: "儲存設定"
      },
      groupuserblacklist: {
        setGroup: "設置群組",
        placeholder: "请选择",
        selGroupUserName: "搜尋群組用戶名稱",
        searchGroupList: "搜尋群組列表",
        GroupList: "群组列表",
        searchGroupUser: "搜尋群组用戶",
        searchresult: "搜尋結果",
        Group_list: "群组列表",
        cancel: "取消",
        blacklist: "拉黑",
        packup: "收起",
        unfold: "展開",
        Blockingusers: "拉黑用戶",
        a: "個",
        batchoperation: "批量操作",
        msg: "從黑名单移除"
      },
      haveGroup: {
        msg: `於空白處滑鼠/手指拖拉向左選取"退出群組"`,
        Enable: `停止開放`,
        Leavingroup: `退出群組`
      },
      index: {
        feedGroup_haveGroup: "現有群組",
        feedGroup_groupSetting: "群組設置",
        feedGroup_groupList: "群組列表",
        feedGroup_userblacklist: "黑名单"
      }
    },
    friend: {
      index: {
        feedGroup_groupAddAcc: "添加好友/群",
        feedGroup_groupAccList: "好友列表",
        feedGroup_groupBlackList: "黑名單"
      }
    }
  },
  Video: {
    AboutMovie: {
      RelatedVideos: `相關影片`
    },
    MoreMovie: {
      MovieList: `影片一覽`,
      All: `全部`,
      order: `排序：`,
      Press: `按最後更新`,
      popularity: `按熱門程度`
    },
    MoreProgram: {
      Ourshow: `我們的節目`,
      All: `全部`,
      order: `排序：`,
      Press: `按最後更新`,
      popularity: `按熱門程度`,
      Updated: `更新至第`,
      episode: `集`,
      total: `共`,
      Lastupdated: `最後更新：`
    },
    programlist: {
      episodes: `集數`
    },
    search: {
      Treasure: `尋寶網搜尋`,
      Topic: `話題`,
      Activities: `活動`,
      album: `相簿`,
      Video: `影音`,
      Shortvideo: `短視頻`,
      Blog: `網誌`,
      search: `搜索`,
      createTime: `相簿建立時間：`,
      searchresult: `搜尋結果`,
      eventresult: `活動搜尋結果`,
      searchMore: `搜尋更多`,
      albumresult: `相簿搜尋結果`,
      topicresult: `話題搜尋結果`,
      videoresult: `影音搜尋結果`,
      blogresult: `網誌搜尋結果`,
      storyresult: `短視頻搜尋結果`
    },
    VideoIndex: {
      EditorChoice: `編輯精選`,
      Ourshow: `我們的節目`,
      More: `更多`,
      NEW: `最新影片`,
      showMore: `展示更多`
    },
    WatchVideo: {
      Posted: `發佈於`,
      bookmark: `收藏`,
      share: `分享`,
      type: `類型：`,
      keyword: `關鍵字`
    }
  },
  ...zhLocale
};
export default zh;


// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js